export const fmtNum = (v, dec) => {
  if (v === null || v === undefined || v === '') return '';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  const s = dec === undefined ? String(n) : n.toFixed(dec);
  return s.replace('.', ',');
};
